__turbopack_context__.v({
  "card": "UploadCard-module__XzZ4Xa__card",
  "description": "UploadCard-module__XzZ4Xa__description",
  "dragOver": "UploadCard-module__XzZ4Xa__dragOver",
  "dropZone": "UploadCard-module__XzZ4Xa__dropZone",
  "heading": "UploadCard-module__XzZ4Xa__heading",
  "root": "UploadCard-module__XzZ4Xa__root",
  "tipContent": "UploadCard-module__XzZ4Xa__tipContent",
  "tipHeader": "UploadCard-module__XzZ4Xa__tipHeader",
  "tipHeaderText": "UploadCard-module__XzZ4Xa__tipHeaderText",
  "tipPanel": "UploadCard-module__XzZ4Xa__tipPanel",
});
